<template>
	<div class="px-1">
		<app-table
			class="mt-3 is-not-selectable"
			name="dealers"
			:columns="columns"
			:rows="rows"
			:current-page="currentPage"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
			>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable"
				v-show="showRow(columns, 1)">
					{{ props.row.fullName }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.email }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.phone }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.numDocument }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.country.data.name }}
				</td>
				<td v-show="showRow(columns, 6)">
					<app-tooltip-button
						color="blue"
						icon="swap_horiz"
						text="Recursos"
						@click-icon="goToResource(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="highlight"
						text="Proyectos"
						@click-icon="goToProjects(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="router"
						text="Aplicaciones"
						@click-icon="goToApplications(props.row)"
					/>
					<app-tooltip-button 
						color="blue"
						icon="web"
						text="Template"
						@click-icon="goToTemplate(props.row)"
						/>
					<app-tooltip-button
						color="blue"
						icon="perm_identity"
						text="Implementadores"
						@click-icon="goToImplementers(props.row)"
						/>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar App"
						@click-icon="goToDeatil(props.row.id)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar"
						@click-icon="openDialog(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteDealers"
					>
						SI
					</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>
						NO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

function goToProjects({ name, id }) {
	const parsedName = name.split(' ').join('-');
	this.goTo('page-dealers-projects', { params: { name: parsedName, id } });
}

function goToTemplate({ id }) {
	this.goTo('page-config-template', { params: { id } });
}

function goToImplementers({ id }) {
	this.goTo('page-dealers-implementers', { params: { id } });
}

function goToResource({ id }) {
	this.goTo('page-dealers-resource', { params: { id } });
}

function goToApplications({ id }) {
	this.goTo('page-dealers-application', { params: { id } });
}

async function loadData() {
	this.params.page = this.currentPage;
	try {
		const response = await this.$http.get('distributaries', { params: this.params });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function goToDeatil(id) {
	this.goTo('page-dealers-new', { params: { id } });
}

function newRoute(newValue, afterValue) {
	if (newValue.name === 'page-config-dealers' && afterValue.name === 'page-dealers-new') {
		this.loadData();
	}
}

function openDialog(item) {
	this.dialogMessage = `¿Desea eliminar de la lista a '${item.name}'?`;
	this.idDelete = item.id;
	this.dialog = true;
}

function closeDialog() {
	this.dialog = false;
	this.dialogMessage = '';
	this.idDelete = null;
}

async function deleteDealers() {
	try {
		await this.$http.delete(`distributaries/${this.idDelete}`);
		this.showNotification('Se eliminó correctamente');
		this.closeDialog();
		this.loadData();
	} catch (error) {
		if (error.status === 405) {
			if (error.data.message === 'USER_HAS_ASSOCIATED_DATA') {
				this.showError('Tiene datos asociados');
			}
		} else {
			this.showError();
		}
	}
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Correo', value: 'email', checked: true, visible: true },
			{ id: 3, name: 'Teléfono', value: 'phone', checked: true, visible: true },
			{ id: 4, name: '#Compañia', value: 'company', checked: true, visible: true },
			{ id: 5, name: 'País', value: 'country', checked: true, visible: true },
			{ id: 6, name: 'Acciones', value: 'actions', checked: true, visible: true },
		],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		params: {
			page: 1,
		},
		dialog: false,
		dialogMessage: '',
		idDelete: null,
	};
}

export default {
	name: 'dealers-list',
	data,
	created,
	methods: {
		closeDialog,
		changePage,
		deleteDealers,
		onSearch,
		goToApplications,
		goToImplementers,
		goToProjects,
		goToResource,
		goToTemplate,
		loadData,
		goToDeatil,
		openDialog,
	},
	components: {
		appTooltipButton,
	},
	watch: {
		$route: newRoute,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/configuration/dealers-list.vue